export default __webpack_public_path__ + "static/media/cropDrawingToolsGif.178bf70b.gif";